/**
 * Sales unless Split returned an explicit off treatment. flipdish-global always
 * keeps Sales regardless of the flag (cross-org aggregate view).
 */
export const shouldShowSalesNavForApp = (
  appId: string | undefined | null,
  isFlagExplicitlyOff: boolean
): boolean => appId === 'flipdish-global' || !isFlagExplicitlyOff;
